'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { SiteSelectPage } from './-components/SiteSelectPage';
export const Route = createFileRoute('/_staff/labor-core/_egov-mock/worker-roster/')({
  component: SiteSelectPage
});